import { useDataChange, useDataValue } from 'Simple/Data.js'

export function useOnClick(props) {
  let change = useDataChange({
    context: 'selected',
    path: 'stages',
    viewPath: props.viewPath,
  })

  let stages = useDataValue({
    context: 'selected',
    path: 'stages',
    viewPath: props.viewPath,
  })

  let isLast = useDataValue({
    context: 'selected_stage_item',
    path: 'isLast',
    viewPath: props.viewPath,
  })

  let id = useDataValue({
    context: 'selected_stage',
    path: 'id',
    viewPath: props.viewPath,
  })

  return function onClick() {
    if (isLast || stages.length === 2) return

    let newStages = stages
      .filter(stage => stage.id !== id)
      .map((stage, index) => ({ ...stage, order: index + 1 }))

    change(newStages)
  }
}

export function useOnChange(props) {
  let change = useDataChange({
    context: 'selected',
    path: 'stages',
    viewPath: props.viewPath,
  })

  let stages = useDataValue({
    context: 'selected',
    path: 'stages',
    viewPath: props.viewPath,
  })

  let id = useDataValue({
    context: 'selected_stage',
    path: 'id',
    viewPath: props.viewPath,
  })

  return function onChange(value) {
    let newStages = stages.map(item =>
      item.id === id ? { ...item, text: value } : item
    )

    change(newStages)
  }
}

export function itemDisabled(isLast, stages, stage) {
  return (
    isLast ||
    stages.length === 2 ||
    stage?.tasks_aggregate?.aggregate?.count > 0
  )
}
